export const MAKEUP_PRODUCT_TYPE_REGIONS: Readonly<Record<string, readonly string[]>> = {
  EYELINER: ["eyeliner"],
  EYESHADOW: ["eyeshadow"],
  MASCARA: ["eyelashes"],
  BLUSH: ["blush"],
  FOUNDATION: ["foundation"],
  LIPSTICK: ["lipstick"],
  EYEBROWS: ["eyebrows"],
  HIGHLIGHTER: ["highlighter"],
  CONTOUR: ["contour"],
  CONCEALER: ["concealer"],
  EYE_COLOR: ["eyeshadow"],
  LIPLINER: ["lipsliner"],
  GLOSS: ["lipstick"],
  BB_CC_CREAM: ["foundation"],
  POWDER: ["foundation"],
  EYES_AND_BROWS: ["eyebrows", "eyeshadow"],
  CHEEKS: ["blush", "contour"],
  BRONZER: ["blush", "contour"],
  PRIMERS: ["foundation"],
  LIP_BALM: ["lipstick"],
  FOUNDATION_CLEAR: ["concealer", "foundation"],
  FOUNDATION_MEDIUM_CLEAR: ["concealer", "foundation"],
  FOUNDATION_MEDIUM: ["concealer", "foundation"],
  FOUNDATION_MEDIUM_DARK: ["concealer", "foundation"],
  FOUNDATION_DARK: ["concealer", "foundation"],
}

/**
 * Legacy grouping categories carried over from the pre-platform enum. They stay
 * RESOLVABLE — products saved on them must keep loading and saving — but they
 * are no longer SELECTABLE, because they name a zone rather than a product a
 * merchant can pick. The Shopify importer has to run a product-title heuristic
 * to collapse them onto a single region, which is exactly why they cannot be
 * offered as a type.
 */
export const DEPRECATED_MAKEUP_PRODUCT_TYPES: ReadonlySet<string> = new Set([
  "EYES_AND_BROWS",
  "CHEEKS",
])

export const isSupportedMakeupProductType = (name: string): boolean =>
  Object.prototype.hasOwnProperty.call(MAKEUP_PRODUCT_TYPE_REGIONS, name) &&
  MAKEUP_PRODUCT_TYPE_REGIONS[name].length > 0

/**
 * What the Product type dropdown may offer. Distinct from
 * {@link isSupportedMakeupProductType}, which answers the *rendering* question
 * ("does this type map to at least one effect region?") and therefore keeps
 * saying yes to the umbrella categories.
 */
export const isSelectableMakeupProductType = (name: string): boolean =>
  isSupportedMakeupProductType(name) && !DEPRECATED_MAKEUP_PRODUCT_TYPES.has(name)

export const isSupportedMakeupProductTypeId = (
  types: ReadonlyArray<{ id: string; name: string }>,
  typeId: string
): boolean => types.some((type) => type.id === typeId && isSupportedMakeupProductType(type.name))

export const getMakeupRegionsForProductType = (name: string | undefined): string[] =>
  name && isSupportedMakeupProductType(name) ? [...MAKEUP_PRODUCT_TYPE_REGIONS[name]] : []
